// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3nbi_","name":"ConsentHeader_name__2JntK","birthday":"ConsentHeader_birthday__31ZbI","skeleton":"ConsentHeader_skeleton__BvnT_"};